import React, { useState, useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "../components/Ad.css";
import Header from "../components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPersonCircleCheck,
  faMoneyBillTransfer,
  faComment,
  faBookOpenReader,
  faChalkboardUser,
  faHourglassHalf,
  faCalendarAlt,
  faMoneyCheckDollar,
  faMoneyBill,
} from "@fortawesome/free-solid-svg-icons";
import "react-calendar/dist/Calendar.css";
import "bootstrap/dist/css/bootstrap.min.css";
// import LearnImage from '../images/Learn.jpeg'
import LearnImage from "../images/learn.jpg";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Link } from "react-router-dom";
import { faMapMarkerAlt, faPhone } from "@fortawesome/free-solid-svg-icons";
import axios, { renderDoc } from "../Axiosinstance";
import Cap from "../images/Cap.jpg";
import { encryptData } from "../Axiosinstance";
import { buttonBackgroundColor } from '../common'
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  TablePagination,
  Card,
  CardContent,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  DialogContentText,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";

import { Button, Modal, Spinner } from "react-bootstrap";
import Loader from "../Loader";
import {
  faUserGraduate,
  faUserTie,
  faLayerGroup,
  faChalkboard,
  faBook,
} from "@fortawesome/free-solid-svg-icons";
import Studentreq from "./Studentreq";
import StudentPayment from "./StudentPayments";
import { Tabs, Tab, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  faTasks,
  faProjectDiagram,
  faBell,
  faTicketAlt,
  faBullhorn,
  faTable,
} from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactPaginate from "react-paginate";
import { FaChalkboardTeacher } from "react-icons/fa";
import { format } from "date-fns";
import Editstudent from "./EditStudent";
import Offlinepayments from "./Offlinepayments";
import Defferred from "./Defferred";
import Enqiuery from "./Enqiuery";
import CircularProgress from "@material-ui/core/CircularProgress";
import { removeBracketedText } from "../Axiosinstance";
import Pending from "./Pending";
import { CategoryStudentWise } from "./CategoryStudentWise";
import * as XLSX from "xlsx";


const styles = {
  buttonContainer: {
    display: "flex",
    gap: "5px", // Adds spacing between buttons
    flexWrap: "wrap", // Allows buttons to wrap if space is small
    justifyContent: "center", // Centers buttons inside the table cell
  },
  button: {
    flex: 1, // Makes buttons take equal space
    minWidth: "80px", // Ensures buttons don't shrink too much
    padding: "8px 12px", // Adds better touch area
    fontSize: "14px",
    borderRadius: "5px",
    textAlign: "center",
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
    flexWrap: "wrap", // Allows wrapping on small screens
    width: "100%",
  },
  input: {
    padding: "9px",
    fontSize: "16px",
    flex: 1, // Takes available space
    minWidth: "150px", // Prevents shrinking too much
    boxSizing: "border-box",
  },
  Button: {
    whiteSpace: "nowrap", // Prevents text from breaking
    padding: "10px 15px",
    fontSize: "14px",
    minWidth: "120px", // Ensures button stays visible
    textAlign: "center",
  },
};
const Ap = () => {
  return (
    <div className="containerd" style={{ textAlign: 'center', padding: '35px', marginTop: '-2%' }} >
      <h1
        className="welcome-heading"
        style={{

          color: "#2186C8",
          fontSize: "2.5rem",
          fontWeight: "bold",
          textShadow:
            "2px 2px 0px white, -2px -2px 0px white, 2px -2px 0px white, -2px 2px 0px white",
        }}
      >
        <span id="head" style={{ color: "#2186C8" }}>
          JURONG ACADEMY
        </span>
      </h1>
      <h4
        className="welcome-heading"
        style={{
          color: "#d4af37",
          fontSize: "1.0rem",
          fontWeight: "bold",
          marginBottom: "10px",
        }}
      >
        Student Learning Management System
      </h4>
    </div>
  );
};

const Dashboard = () => {
  const [studentdata1, setstudentdata1] = useState(0);
  const [staffdata2, setstaffdata2] = useState(0);
  const [batchdata3, setbatchdata3] = useState(0);
  const [coursesdata4, setcoursesdata4] = useState(0);
  const [activeStudent, setActiveStudent] = useState(0);
  const [counts, setCounts] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          response1,
          response2,
          response3,
          response4,
          response5,
          response6,
        ] = await Promise.all([
          axios.get("student/count"),
          axios.get("facilitator/count"),
          axios.get("course/count"),
          axios.get("category/count"),
          axios.get("courses/countByType"),
          axios.get("student/count/active"),
        ]);
        setstudentdata1(response1.data);
        setstaffdata2(response2.data);
        setbatchdata3(response3.data);
        setcoursesdata4(response4.data);
        setCounts(response5.data);
        setActiveStudent(response6.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const totals = [
    // { name: 'Total Students', count: studentdata1, icon: faUserGraduate, path: '/Allstudent' },
    {
      name: "Active Students",
      count: activeStudent,
      icon: faUserGraduate,
      path: "/Allstudent",
    },
    {
      name: "Total Staff",
      count: staffdata2,
      icon: faChalkboardUser,
      path: "/Facilitor",
    },
    // { name: 'Department wise Student', count: 30, icon: faLayerGroup, path: '/Allstudent' },
    {
      name: "Diploma Courses",
      count: counts.diploma,
      icon: faBookOpenReader,
      path: "/AllCourse",
      type: "diploma",
    },
    {
      name: "Advance Diploma Courses",
      count: counts.advance_diploma,
      icon: faBook,
      path: "/AllCourse",
      type: "advance_diploma",
    },
    {
      name: "Payment Log ",
      // count: counts.advance_diploma,
      icon: faBook,
      path: "/paymentlog",
      //   type: "advance_diploma",
    },
    {
      name: "Alumini ",
      // count: counts.advance_diploma,
      icon: faUserGraduate,
      path: "/AluminiDetails",
    }
  ];

  const handleNavigation = (path, params = {}) => {
    if (path === "/AllCourse") {
      const searchParams = new URLSearchParams(params).toString();
      navigate(`${path}?${searchParams}`);
    } else {
      navigate(path);
    }
  };

  const [hoverIndex, setHoverIndex] = useState(null);

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        padding: "20px",
        backgroundColor: "rgba(255, 255, 255, 0.3)", // White with 50% opacity
        borderRadius: "10px",
        boxShadow: "0 8px 15px rgba(0, 0, 0, 0.2)", // Shadow effect
        maxWidth: "1300px",
        margin: "0 auto",
        flexWrap: "wrap",
        marginTop: "-40px",
        gap: "20px", // Added gap between cards
      }}
    >
      {totals.map((item, index) => (
        <div
          key={index}
          onClick={() => handleNavigation(item.path, { courseType: item.type })}
          onMouseEnter={() => setHoverIndex(index)}
          onMouseLeave={() => setHoverIndex(null)}
          style={{
            display: "flex",
            alignItems: "center",
            borderRadius: "12px",
            overflow: "hidden",
            cursor: "pointer",
            boxShadow:
              hoverIndex === index
                ? "0 10px 20px rgba(0, 0, 0, 0.15)"
                : "0 4px 8px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#f5f5f5",
            transition: "transform 0.4s ease",
            transform: hoverIndex === index ? "scale(1.05)" : "scale(1)",
            width: "300px", // Set a fixed width to avoid stretching
          }}
        >
          {/* Left Icon Panel */}
          <div
            style={{
              width: "100px",
              height: "100px",
              backgroundColor: hoverIndex === index ? "#0277bd" : "#d18828",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
            }}
          >
            <FontAwesomeIcon icon={item.icon} style={{ fontSize: "28px" }} />
          </div>

          {/* Right Data Panel */}
          <div style={{ flex: 1, padding: "20px" }}>
            <div
              style={{ fontSize: "24px", fontWeight: "600", color: "#37474f" }}
            >
              {item.count}
            </div>
            <div
              style={{
                fontSize: "16px",
                fontWeight: "bolder",
                color: "#122c4a",
              }}
            >
              {item.name}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const WelcomeBoxes = () => {
  const [count, setCount] = useState();
  const [countStudent, setCountStudent] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showStudentReq, setShowStudentReq] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showOffline, setShowOffline] = useState(false);
  const [showdefferred, setShowdefferred] = useState(false);
  const [showenqiuery, setShowenqiuery] = useState(false);
  const [showPending, setShowPending] = useState(false);

  const [unapprovedCount, setUnapprovedCount] = useState();

  const navigate = useNavigate();

  const handleOpenOffline = () => {
    setShowOffline(true);
  };

  const handleCloseOffline = () => {
    setShowOffline(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response1 = await axios.get("batch/count");
        const response2 = await axios.get("requeststudents/count");
        const response3 = await axios.get("registrationadvances/count/new");
        setCount(response1.data);
        setCountStudent(response2.data);
        setUnapprovedCount(response3.data);
      } catch (error) {
        console.error("Error fetching batch count:", error);
      }
    };

    fetchData();
  }, []);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleOpenStudentReq = () => {
    setShowStudentReq(true);
  };

  const handleCloseStudentReq = () => {
    setShowStudentReq(false);
  };

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
  };

  const handleOpendefferred = () => {
    setShowdefferred(true);
  };

  const handleClosedefferred = () => {
    setShowdefferred(false);
  };

  const handleOpenenqiuery = () => {
    setShowenqiuery(true);
  };

  const handleCloseenqiuery = () => {
    setShowenqiuery(false);
  };

  const handleOpenPending = () => {
    setShowPending(true); // Open Pending modal
  };

  const handleClosePending = () => {
    setShowPending(false); // Close Pending modal
  };

  const [hoveredCard, setHoveredCard] = useState(null);

  const handleMouseEnter = (index) => setHoveredCard(index);
  const handleMouseLeave = () => setHoveredCard(null);

  const cards = [
    {
      title: "Approve Registration",
      description: "View and Approve Registration",
      icon: faPersonCircleCheck,
      count: unapprovedCount,
      onClick: openModal,
    },
    {
      title: "Manual Payments",
      description: "View and students Payments Detail",
      icon: faMoneyBillTransfer,
      onClick: handleOpenOffline,
    },
    {
      title: "Defferred",
      description: "View and Know the Details of Defferred",
      icon: faHourglassHalf,
      onClick: handleOpendefferred,
    },
    {
      title: "Enquiry",
      description: "View and Know the Details of Enquiry",
      icon: faComment,
      onClick: handleOpenenqiuery,
    },
    {
      title: "Offline Payment",
      description: "View Offline Payment Details",
      icon: faMoneyCheckDollar,
      onClick: handleOpenStudentReq,
    },
    {
      title: "Pending",
      description: "View and Know the Pending Details",
      icon: faCalendarAlt,
      onClick: handleOpenPending,
    },
  ];

  return (
    <>
      <div
        className="container"
        style={{
          maxWidth: "1300px",
          margin: "0 auto",
          padding: "20px",
          backgroundColor: "rgba(255, 255, 255, 0.3)", // White with 50% opacity
          borderRadius: "20px",
          boxShadow: "0 8px 15px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Grid container spacing={2} justifyContent="center">
          {cards.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                onClick={card.onClick}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
                sx={{
                  display: "flex",
                  flexDirection: "row", // Align items horizontally
                  alignItems: "center",
                  margin: "5px 0",
                  borderRadius: "12px",
                  overflow: "hidden",
                  cursor: "pointer",
                  transition:
                    "transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease",
                  transform: hoveredCard === index ? "scale(1.05)" : "scale(1)",
                  backgroundColor:
                    hoveredCard === index ? "#f0f8ff" : "#ffffff", // Light blue background on hover
                  boxShadow:
                    hoveredCard === index
                      ? "0 8px 15px rgba(0, 0, 0, 0.2)"
                      : "0 4px 8px rgba(0, 0, 0, 0.1)",
                  padding: "15px",
                }}
              >
                {/* Left side with Icon and background */}
                <div
                  style={{
                    width: "20%",
                    height: "60px", // Adjust the height as needed
                    backgroundColor: "#0277bd", // Icon background color
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "8px",
                    marginRight: "15px", // Spacing between icon and text
                  }}
                >
                  <FontAwesomeIcon
                    icon={card.icon}
                    size="2x"
                    style={{
                      color: "#ffffff",
                      transition: "color 0.3s ease",
                    }}
                  />
                </div>

                {/* Right side with Title, Count and Description */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  <div style={{ flex: 1, textAlign: "left" }}>
                    <Typography
                      variant="h6"
                      component="h3"
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#333333",
                        marginBottom: "5px",
                      }}
                    >
                      {card.title}
                    </Typography>

                    {/* Optional Description Section */}
                    {card.description && (
                      <Typography
                        variant="body2"
                        style={{
                          color: "#555555",
                          fontSize: "14px",
                          lineHeight: "1.0",
                          marginTop: "10px",
                          textAlign: "left", // Align description to the left
                        }}
                      >
                        {card.description}
                      </Typography>
                    )}
                  </div>

                  {/* Count aligned to the right */}
                  {card.count && (
                    <Typography
                      variant="h4"
                      component="h1"
                      style={{
                        fontSize: "34px",
                        fontWeight: "bold",
                        color: "#007bff",
                        textAlign: "right",
                      }}
                    >
                      {card.count}
                    </Typography>
                  )}
                </div>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Modal
          show={showModal}
          onHide={closeModal}
          dialogClassName="modal-fullscreen"
        >
          <Modal.Header closeButton>
            <Modal.Title>New Registration</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tablerow />
            <ToastContainer />
          </Modal.Body>
          <Modal.Footer>
            <button variant="contained"
              style={{
                backgroundColor: buttonBackgroundColor,
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "16px",
                cursor: "pointer",
                boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
              }}

              onClick={closeModal}>
              Close
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showStudentReq}
          onHide={handleCloseStudentReq}
          dialogClassName="modal-fullscreen"
        >
          <Modal.Header closeButton>
            <Modal.Title>Offline Payments</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Studentreq />
            <ToastContainer />
          </Modal.Body>
          <Modal.Footer>
            <button variant="contained"
              style={{
                backgroundColor: buttonBackgroundColor,
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "16px",
                cursor: "pointer",
                boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
              }}

              onClick={handleCloseStudentReq}>
              Close
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showOffline}
          onHide={handleCloseOffline}
          dialogClassName="modal-fullscreen"
        >
          <Modal.Header closeButton>
            <Modal.Title>Offline Payments for new student</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Offlinepayments />
            <ToastContainer />
          </Modal.Body>
          <Modal.Footer>
            <button variant="contained"
              style={{
                backgroundColor: buttonBackgroundColor,
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "16px",
                cursor: "pointer",
              }}

              onClick={handleCloseOffline}>
              Close
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showPaymentModal}
          onHide={handleClosePaymentModal}
          dialogClassName="modal-fullscreen"
        >
          <Modal.Header closeButton>
            <Modal.Title>Students Payments</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <StudentPayment />
            <ToastContainer />
          </Modal.Body>
          <Modal.Footer>
            <button variant="contained"
              style={{
                backgroundColor: buttonBackgroundColor,
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "16px",
                cursor: "pointer",
                boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
              }}
              onClick={handleClosePaymentModal}>
              Close
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showdefferred}
          onHide={handleClosedefferred}
          dialogClassName="modal-fullscreen"
        >
          <Modal.Header closeButton>
            <Modal.Title>Defferred</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Defferred />
            <ToastContainer />
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={handleClosedefferred}
              style={{
                backgroundColor: buttonBackgroundColor,
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "16px",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
                boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = "#0056b3"}
              onMouseOut={(e) => e.target.style.backgroundColor = "#007bff"}
            >
              Close
            </button>

          </Modal.Footer>
        </Modal>

        <Modal
          show={showenqiuery}
          onHide={handleCloseenqiuery}
          dialogClassName="modal-fullscreen"
        >
          <Modal.Header closeButton>
            <Modal.Title>Enquiry</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <br />
            <Enqiuery />
            <ToastContainer />
          </Modal.Body>
          <Modal.Footer>
            <button variant="contained"
              style={{
                backgroundColor: buttonBackgroundColor,
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "16px",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
              onClick={handleCloseenqiuery}>
              Close
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showPending}
          onHide={handleClosePending}
          dialogClassName="modal-fullscreen"
        >
          <Modal.Header closeButton>
            <Modal.Title>Pending</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Pending /> {/* Display Pending component */}
            <ToastContainer />
          </Modal.Body>
          <Modal.Footer>
            <button variant="contained"
              style={{
                backgroundColor: buttonBackgroundColor,
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "16px",
                cursor: "pointer",
                boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
              }}

              onClick={handleClosePending}>
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

const Tablerow = () => {
  const [loading, setLoading] = useState(true);
  const [students, setStudents] = useState([]);
  const [diplomaPage, setDiplomaPage] = useState(0);
  const [diplomaRowsPerPage, setDiplomaRowsPerPage] = useState(5);
  // Advanced Diploma pagination state
  const [advancedDiplomaPage, setAdvancedDiplomaPage] = useState(0);
  const [advancedDiplomaRowsPerPage, setAdvancedDiplomaRowsPerPage] =
    useState(5);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [openApproveDialog, setOpenApproveDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [studentDetails, setStudentDetails] = useState(null);
  const classes = useStyles();
  const [scheduleData, setScheduleData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isApproving, setApproving] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const [approver, setApprover] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchAdvanceDiploma, setSearchAdvanceDiploma] = useState("");


  const loggedInUserId = localStorage.getItem("loggedInUserId");
  const userType = localStorage.getItem("usertype");


  const [uploadedFiles, setUploadedFiles] = useState({
    workPermitSpass: null,
    workPermitOne: null,
    passport: null,
    markSheet: null,

    profilePicture: null,
  });

  const fetchData = async () => {
    try {
      // const response = await axios.get(
      //   `/registrationadvances/unapprovedPaymentTypes?approveReference=${loggedInUserId}`
      // );


      let response
      console.log(userType, "userType")
      if (userType == 4) {
        response = await axios.get(
          `registrationadvances/new-students`
        );
      }
      else if (userType == 3) {
        response = await axios.get(
          `registrationadvances/unapprovedPaymentTypes?approveReference=${loggedInUserId}`
        );
      }


      setStudents(response.data); // Assuming the response data is an array of student objects
      // setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []); // Fetch data when component mounts

  const [open, setOpen] = useState(false);
  const [documentType, setDocumentType] = useState("");

  const handleOpenModal = (docType) => {
    setDocumentType(docType);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleDiplomaChangePage = (event, newPage) => {
    setDiplomaPage(newPage);
  };
  const handleDiplomaChangeRowsPerPage = (event) => {
    setDiplomaRowsPerPage(parseInt(event.target.value, 10));
    setDiplomaPage(0);
  };
  const handleAdvancedDiplomaChangePage = (event, newPage) => {
    setAdvancedDiplomaPage(newPage);
  };
  const handleAdvancedDiplomaChangeRowsPerPage = (event) => {
    setAdvancedDiplomaRowsPerPage(parseInt(event.target.value, 10));
    setAdvancedDiplomaPage(0);
  };

  const handleVerifyFile = (docType) => {
    // Perform verification logic here
    toast.success(`File "${docType}" verified successfully!`);
    handleCloseModal();
  };

  const handleFileRemove = (category) => {
    setUploadedFiles((prevState) => ({
      ...prevState,
      [category]: null,
    }));
  };

  const handleApproveClick = (student) => {
    console.log(student);
    setSelectedStudent(student);
    setOpenApproveDialog(true);
  };

  useEffect(() => {
    fetchData();
    const storedName = localStorage.getItem("name");
    // console.log('Stored Name:', storedName); // Check if localStorage name is retrieved correctly
    if (storedName) {
      setApprover(storedName);
    }
  }, []);

  const handleApprove = async () => {
    setApproving(true);
    try {
      const { id } = selectedStudent;

      // Encrypt data to be used in the URL
      const dataToEncrypt = { id: id };
      const encryptedData = encryptData(dataToEncrypt);

      // Construct the URL with encrypted data
      const pdfurl = `${window.location.origin
        }/paymentspage?=${encodeURIComponent(encryptedData)}`;

      // Send invoice with the constructed URL as a parameter
      // console.log(pdfurl + " pdfurl");
      // console.log(id + " id");

      const name = localStorage.getItem("name");

      await axios.post(`/registrationadvances/sendInvoice`, null, {
        params: {
          Id: id,
          pdfUrl: pdfurl,
          approver: name,
          approverId: loggedInUserId,
        },
      });

      toast.success("Student approved and activated successfully");
      setOpenApproveDialog(false);
      fetchData(); // Refresh data after approval

      // Redirect or navigate if necessary
      // navigate(`/paymentspage?data=${encodeURIComponent(encryptedData)}`); // Uncomment if you want to navigate
    } catch (error) {
      console.error("Error approving student:", error);
      toast.error("Error approving student");
      setOpenApproveDialog(false);
    } finally {
      setApproving(false);
    }
  };

  const handleDeleteClick = (student) => {
    setSelectedStudent(student);
    setOpenDeleteDialog(true);
  };

  const handleDelete = async () => {
    try {
      const response = await axios.post(
        `/registrationadvances/${selectedStudent.id}/reject`
      );
      console.log("Student rejected:", response.data);
      toast.success("Student  Rejected successfully", {
        autoClose: 3000, // 3 seconds
      });

      setOpenDeleteDialog(false);
      fetchData(); // Refresh data after deletion
    } catch (error) {
      console.error("Error rejected student:", error);
      toast.error("Error rejected student");
      setOpenDeleteDialog(false);
    }
  };

  const handleCancelApprove = () => {
    setOpenApproveDialog(false);
    setSelectedStudent(null);
  };

  const handleViewClick = async (student) => {
    setLoading(true);
    try {
      const response = await axios.get(`/registrationadvances/${student.id}`);
      const { scheduleDate, markSheet, batch, ...studentData } = response.data;

      // Copy batch details to studentData
      const updatedStudentData = { ...studentData, batch };

      // Create a map for moduleDetails based on id
      const moduleDetailsMap = {};
      batch?.moduleDetails.forEach((module) => {
        moduleDetailsMap[module.id] = module.moduleName;
      });

      // Map the module details to the schedule data based on startModulus
      const updatedScheduleData = scheduleDate.map((schedule) => {
        const moduleDetail = batch?.moduleDetails.find(
          (module) => module.id === schedule.startModulus
        );
        return {
          ...schedule,
          moduleDetail: moduleDetail ? moduleDetail.moduleName : "N/A",
        };
      });

      // Update student details and schedule data
      setStudentDetails({ ...updatedStudentData, markSheet });
      setScheduleData(updatedScheduleData);

      // Log for debugging purposes
      // console.log("Student Data:", updatedStudentData);
      // console.log("Updated Schedule Data:", updatedScheduleData);
      // console.log("Response Data:", response.data);

      // Set uploaded files including markSheet
      setUploadedFiles({
        workPermitSpass: studentData.workPermitSpass,
        workPermitOne: studentData.workPermitOne,
        passport: studentData.passport,
        markSheet: markSheet, // Set markSheet

        profilePicture: studentData.profilePicture,
      });

      setOpenViewDialog(true);
    } catch (error) {
      console.error("Error fetching student details:", error);
      toast.error("Error fetching student details");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelDelete = () => {
    setOpenDeleteDialog(false);
    setSelectedStudent(null);
  };

  console.log(studentDetails);

  const handleCloseViewDialog = () => {
    setOpenViewDialog(false);
    setStudentDetails(null);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  function formatDateEnd(dateString) {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  }

  const handleEditClick = (student) => {
    setSelectedStudent(student); // Set the selected student in state
    setIsModalOpen(true); // Open the modal when edit is clicked
  };

  const markSheets = studentDetails?.markSheet;
  const certificate = studentDetails?.certificate;
  const institutionDetails = studentDetails?.institutionDetails || [];

  // Filter out any keys that contain "Progress" or "Status"
  const filteredMarkSheets = markSheets
    ? Object.entries(markSheets).filter(
      ([key]) => !key.includes("Progress") && !key.includes("Status")
    )
    : [];
  const filteredCertificate = certificate
    ? Object.entries(certificate).filter(
      ([key]) => !key.includes("Progress") && !key.includes("Status")
    )
    : [];


  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const handleSearchChange2 = (event) => {
    setSearchAdvanceDiploma(event.target.value);
  };

  const exportToExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  const handleDownloadExcel = () => {
    const filteredData = students
      .filter((student) => student.type === "advance_diploma")
      .filter((student) =>
        student.nric.toLowerCase().includes(searchAdvanceDiploma.toLowerCase()) ||
        student.name.toLowerCase().includes(searchAdvanceDiploma.toLowerCase()) &&
        !(student.paymentStatus === "Pending" && student.paymentType === "offline")
      )
      .map((student, index) => ({
        "S.No": advancedDiplomaPage * advancedDiplomaRowsPerPage + index + 1,
        "Name": student.student.name.toUpperCase(),
        "Phone No": student.handPhone,
        "Courses": removeBracketedText(student.batch.course),
        "Status": student.approve === "false" ? "Pending" : student.status
      }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Advanced Diploma Students");

    XLSX.writeFile(wb, "Advanced_Diploma_Students.xlsx");
  };


  return (
    <div className="container-responsive">
      <ToastContainer />
      {/* <div style={{ marginBottom: "15px" }}>
        <input
          type="text"
          placeholder="Search by Name"
          value={searchQuery}
          onChange={handleSearchChange}
          style={{
            padding: "10px",
            fontSize: "16px",
            width: "100%",
            boxSizing: "border-box",
          }}
        />
      </div> */}
      <h2
        className="heading"
        align="center"
        style={{ color: "#FFFFFF", fontSize: "28px" }}
      >
        Diploma Registration
      </h2>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
        <input
          type="text"
          placeholder="Search by Name and Nric"
          value={searchQuery}
          onChange={handleSearchChange}
          style={{
            padding: "10px",
            fontSize: "16px",
            flex: 1, // Makes the input take the remaining space
            boxSizing: "border-box",
          }}
        />
        <Button
          onClick={() =>
            exportToExcel(
              students
                .filter((student) => student.type === "diploma")
                .filter(
                  (student) =>
                    student.nric.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    student.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
                    !(student.paymentStatus === "Pending" && student.paymentType === "offline")
                )
                .map((student, index) => ({
                  "S.No": index + 1,
                  Name: student.student.name.toUpperCase(),
                  "Phone No": student.handPhone,
                  Courses: student.batch.course.replace(/\s*\(.*?\)\s*/g, ""),
                  Status: student.approve === "false" ? "Pending" : student.status,
                })),
              "Diploma_Students_Data"
            )
          }
          variant="contained"
          style={{
            backgroundColor: buttonBackgroundColor,
            color: "white",
            minWidth: "150px", // Ensure the button has a minimum width

            height: "48px", // Prevent button from shrinking
          }}
        >
          Download Excel
        </Button>

      </div>

      <TableContainer>
        <Table style={{ borderCollapse: "collapse", border: "1px solid #ccc" }}>
          <TableHead>
            <TableRow>
              {["S.No", "Name", "Phone No", "Nric", "Courses", "Status", "Action", "View"].map((header) => (
                <TableCell key={header} align="center" style={{ fontWeight: "bold" }}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {students
              .filter((student) => student.type === "diploma")
              .sort((a, b) => b.id - a.id)
              .filter(
                (student) =>
                  (student.nric.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    student.name.toLowerCase().includes(searchQuery.toLowerCase())) &&
                  !(student.paymentStatus === "Pending" && student.paymentType === "offline")
              )
              .slice(diplomaPage * diplomaRowsPerPage, diplomaPage * diplomaRowsPerPage + diplomaRowsPerPage)
              .map((student, index) => (
                <TableRow key={student.id}>
                  <TableCell align="center">{diplomaPage * diplomaRowsPerPage + index + 1}</TableCell>
                  <TableCell align="center">{student.student.name.toUpperCase()}</TableCell>
                  <TableCell align="center">{student.handPhone}</TableCell>
                  <TableCell align="center">{student.nric}</TableCell>
                  <TableCell align="center">{student.batch.course.replace(/\s*\(.*?\)\s*/g, "")}</TableCell>
                  <TableCell align="center">{student.approve === "false" ? "Pending" : student.status}</TableCell>
                  <TableCell align="center">
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                      <IconButton onClick={() => handleApproveClick(student)} style={{ backgroundColor: "#28a745", color: "#fff" }}>
                        <CheckIcon />
                      </IconButton>
                      <div style={{ width: "1px", height: "24px", backgroundColor: "#ccc", margin: "0 10px" }}></div>
                      <IconButton onClick={() => handleDeleteClick(student)} style={{ backgroundColor: "#dc3545", color: "#fff" }}>
                        <ThumbDownIcon />
                      </IconButton>
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                      <Button onClick={() => handleViewClick(student)} variant="contained" style={{
                        backgroundColor: buttonBackgroundColor,
                        color: "white",
                        minWidth: "120px", // Ensure the button has a minimum width

                        // Prevent button from shrinking
                      }}>
                        View
                      </Button>
                      <Button onClick={() => handleEditClick(student)} variant="contained" style={{
                        backgroundColor: buttonBackgroundColor,
                        color: "white",
                        minWidth: "120px", // Ensure the button has a minimum width

                        // Prevent button from shrinking
                      }}>
                        Edit
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={
            students.filter((student) => student.type === "diploma").length
          }
          rowsPerPage={diplomaRowsPerPage}
          page={diplomaPage}
          onPageChange={handleDiplomaChangePage}
          onRowsPerPageChange={handleDiplomaChangeRowsPerPage}
        />

        <Modal
          show={isModalOpen}
          onHide={closeModal}
          dialogClassName="modal-fullscreen"
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Student</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Editstudent
              onAction={fetchData}
              from={true}
              studentId={selectedStudent ? selectedStudent.id : null}
            />{" "}
            {/* Pass the selectedStudent.id as studentId prop */}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="contained"
              style={{
                backgroundColor: buttonBackgroundColor,
                color: "white",
              }} onClick={closeModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </TableContainer>

      <h2
        className="heading"
        align="center"
        style={{ color: "#FFFFFF", fontSize: "28px" }}
      >
        Advance Diploma
      </h2>

      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px", marginTop: "5px" }}>

        <input
          type="text"
          placeholder="Search by  Name and Nric"
          value={searchAdvanceDiploma}
          onChange={handleSearchChange2}
          style={{
            padding: "10px",
            fontSize: "16px",
            flex: 1, // Makes the input take the remaining space
            boxSizing: "border-box",
          }}
        />
        <Button variant="contained"
          style={{
            backgroundColor: buttonBackgroundColor,
            color: "white",
            minWidth: "150px", // Ensure the button has a minimum width

            height: "48px", // Prevent button from shrinking
          }}
          onClick={handleDownloadExcel}>
          Download Excel
        </Button>
      </div>

      <TableContainer>
        <Table style={{ borderCollapse: "collapse", border: "1px solid #ccc" }}>
          <TableHead>
            <TableRow>
              {["S.No", "Name", "Phone No", "Nric", "Courses", "Status", "Action", "View"].map((header) => (
                <TableCell key={header} align="center" style={{ fontWeight: "bold" }}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {students
              .filter((student) => student.type === "advance_diploma")
              .sort((a, b) => b.id - a.id)
              .filter((student) =>
                student.nric.toLowerCase().includes(searchAdvanceDiploma.toLowerCase()) ||
                student.name.toLowerCase().includes(searchAdvanceDiploma.toLowerCase()) &&
                !(student.paymentStatus === "Pending" && student.paymentType === "offline")
              )
              .slice(
                advancedDiplomaPage * advancedDiplomaRowsPerPage,
                advancedDiplomaPage * advancedDiplomaRowsPerPage +
                advancedDiplomaRowsPerPage
              )
              .map((student, index) => (
                <TableRow key={student.id}>
                  <TableCell align="center">
                    {advancedDiplomaPage * advancedDiplomaRowsPerPage +
                      index +
                      1}
                  </TableCell >
                  <TableCell align="center">{student.student.name.toUpperCase()}</TableCell>
                  <TableCell align="center">{student.handPhone}</TableCell>
                  <TableCell align="center">{student.nric}</TableCell>
                  <TableCell align="center">
                    {" "}
                    {removeBracketedText(student.batch.course)}
                  </TableCell>
                  <TableCell align="center">
                    {student.approve === "false" ? "Pending" : student.status}
                  </TableCell>
                  <TableCell align="center">
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                      <IconButton
                        onClick={() => handleApproveClick(student)}
                        style={{ backgroundColor: "#28a745", color: "#fff" }}
                      >
                        <CheckIcon />
                      </IconButton>
                      <div
                        style={{
                          width: "1px",
                          height: "24px",
                          backgroundColor: "#ccc",
                          margin: "0 10px",
                        }}
                      ></div>
                      <IconButton
                        onClick={() => handleDeleteClick(student)}
                        style={{ backgroundColor: "#dc3545", color: "#fff" }}
                      >
                        <ThumbDownIcon />
                      </IconButton>
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                      <Button onClick={() => handleViewClick(student)} variant="contained" style={{
                        backgroundColor: buttonBackgroundColor,
                        color: "white",
                        minWidth: "120px", // Ensure the button has a minimum width

                        // Prevent button from shrinking
                      }}>
                        View
                      </Button>
                      <Button onClick={() => handleEditClick(student)} variant="contained" style={{
                        backgroundColor: buttonBackgroundColor,
                        color: "white",
                        minWidth: "120px", // Ensure the button has a minimum width

                        // Prevent button from shrinking
                      }}>
                        Edit
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={
            students.filter((student) => student.type === "advance_diploma")
              .length
          }
          rowsPerPage={advancedDiplomaRowsPerPage}
          page={advancedDiplomaPage}
          onPageChange={handleAdvancedDiplomaChangePage}
          onRowsPerPageChange={handleAdvancedDiplomaChangeRowsPerPage}
        />
      </TableContainer>

      <Dialog fullScreen open={openViewDialog} onClose={handleCloseViewDialog}>
        <DialogTitle>
          <div>
            <Typography
              variant="h4"
              gutterBottom
              style={{ fontWeight: "bold", textAlign: "center" }}
            >
              {studentDetails?.name.toUpperCase() || "-"}
            </Typography>
          </div>
        </DialogTitle>
        <DialogContent>
          {/* <Grid container spacing={4}> */}

          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Paper
                elevation={3}
                style={{
                  padding: "24px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  marginTop: "2%",
                  marginBottom: "4%",
                  // maxWidth: "1500px",
                }}
              >
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{
                    marginBottom: "16px",
                    color: "#333",
                    borderBottom: "2px solid #ccc",
                    paddingBottom: "8px",
                    fontWeight: "bolder",
                  }}
                >
                  Basic Personal Information
                </Typography>
                {studentDetails ? (
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>Name:</strong> {studentDetails.name.toUpperCase() || "-"}
                      </Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                    <Typography variant="body1"><strong>Surname:</strong> {studentDetails.sureName || '-'}</Typography>
                  </Grid> */}
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>Phone No:</strong>{" "}
                        {studentDetails.handPhone || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>Date of Birth:</strong>{" "}
                        {studentDetails.dob || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>Gender:</strong> {studentDetails.gender || "-"}
                      </Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Nationality:</strong> {studentDetails.countryBirth || '-'}</Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>Passport No:</strong>{" "}
                        {studentDetails.passportNo || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>Email:</strong> {studentDetails.email || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>Type:</strong> {studentDetails?.type || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>Course:</strong>{" "}
                        {removeBracketedText(studentDetails?.batch.course) || "-"}
                      </Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Intake:</strong> {studentDetails?.intake || '-'}</Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>Country of Birth:</strong>{" "}
                        {studentDetails?.countryBirth || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>Nationality:</strong>{" "}
                        {studentDetails?.nationality || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>Know About Program:</strong>{" "}
                        {studentDetails?.knowAboutProgram || "-"}
                        {(studentDetails?.knowAboutProgram === "referral" ||
                          studentDetails?.knowAboutProgram === "other") && (
                            <>
                              {" - "}
                              {studentDetails?.knowAboutProgram === "referral"
                                ? studentDetails?.referalfriend || "-"
                                : studentDetails?.otherDetails || "-"}
                            </>
                          )}
                      </Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                    <Typography variant="body1"><strong>Application Signature:</strong> {studentDetails?.applicationSignature || '-'}</Typography>
                  </Grid> */}
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>Date:</strong>{" "}
                        {formatDate(studentDetails?.date) || "-"}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <FontAwesomeIcon icon={faPhone} />{" "}
                        <strong>Phone (Office): </strong>
                        {studentDetails?.phoneOffice || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <FontAwesomeIcon icon={faPhone} />{" "}
                        <strong>Phone (Home): </strong>
                        {studentDetails?.phoneHome || "-"}
                      </Typography>
                    </Grid>
                    {/* <Typography variant="h6" gutterBottom style={{ marginBottom: '16px', color: '#333', borderBottom: '2px solid #ccc', paddingBottom: '8px', fontWeight: 'bolder' }}>Additional Information</Typography> */}

                    {/* <Grid item xs={12} sm={6}>
                    <Typography variant="body1"><strong>Non-Singaporean:</strong> {studentDetails?.nonSingaporean || '-'}</Typography>
                  </Grid> */}
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>Company:</strong> {studentDetails?.company || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1">
                        <strong>
                          {studentDetails?.proofType === "NRIC"
                            ? "NRIC :"
                            : "FIN :"}
                        </strong>{" "}
                        {studentDetails.student?.nric || "-"}
                      </Typography>
                    </Grid>
                    <br />
                    <Grid item xs={12} sm={4}>
                      <Typography>
                        <FontAwesomeIcon icon={faMapMarkerAlt} />{" "}
                        <strong>Address (Office):</strong>{" "}
                        {studentDetails?.addressOffice || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography>
                        <FontAwesomeIcon icon={faMapMarkerAlt} />{" "}
                        <strong>Address (Home):</strong>{" "}
                        {studentDetails?.addressHome || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography>
                        <strong>Contact Name:</strong>{" "}
                        {studentDetails?.emergencyName || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography>
                        <strong>
                          <FontAwesomeIcon icon={faPhone} /> Emergency Contact:
                        </strong>{" "}
                        {studentDetails?.emergencyPhone || "-"}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Typography>
                        <strong>Relation:</strong>{" "}
                        {studentDetails?.emergencyRelation || "-"}
                      </Typography>
                    </Grid>
                  </Grid>
                ) : (
                  <Typography
                    style={{
                      marginTop: "16px",
                      color: "red",
                      textAlign: "center",
                    }}
                  >
                    No information available.
                  </Typography>
                )}
              </Paper>
            </Grid>
            <>
              <Table style={{ maxWidth: "100%", justifyContent: "center", marginLeft: "1.5%", }}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 'bold' }}>Document Name</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>View</TableCell>
                    {/* <TableCell>Verify</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {studentDetails && studentDetails.workPermitSpass && (
                    <TableRow key="workPermitSpass">
                      <TableCell>NRIC/WorkPermit/S-Pass Front</TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: buttonBackgroundColor,
                            color: "white",
                            minWidth: "70px",
                          }}
                          onClick={() =>
                            renderDoc(studentDetails.workPermitSpass)
                          }
                        >
                          View
                        </Button>
                      </TableCell>
                      {/* <TableCell>
                          <Button onClick={() => handleVerifyFile('workPermitSpass')}>Verify</Button>
                        </TableCell> */}
                    </TableRow>
                  )}
                  {studentDetails && studentDetails.workPermitOne && (
                    <TableRow key="workPermitOne">
                      <TableCell>NRIC/WorkPermit/S-Pass Back</TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: buttonBackgroundColor,
                            color: "white",
                            minWidth: "70px",
                          }}
                          onClick={() =>
                            renderDoc(studentDetails.workPermitOne)
                          }
                        >
                          View
                        </Button>
                      </TableCell>
                      {/* <TableCell>
                          <Button onClick={() => handleVerifyFile('workPermitSpass')}>Verify</Button>
                        </TableCell> */}
                    </TableRow>
                  )}

                  {studentDetails && studentDetails.passport && (
                    <TableRow key="passport">
                      <TableCell>Passport</TableCell>
                      <TableCell>
                        <Button variant="contained"
                          style={{
                            backgroundColor: buttonBackgroundColor,
                            color: "white",
                            minWidth: "70px",
                          }}
                          onClick={() => renderDoc(studentDetails.passport)}
                        >
                          View
                        </Button>
                      </TableCell>
                      {/* <TableCell>
                          <Button onClick={() => handleVerifyFile('passport')}>Verify</Button>
                        </TableCell> */}
                    </TableRow>
                  )}
                  {filteredMarkSheets.map(
                    ([level, url], index) =>
                      url && ( // Only display the row if the url is present
                        <TableRow key={level}>
                          <TableCell>
                            Marksheet for{" "}
                            {institutionDetails[index]?.institution ||
                              "Unknown Institution"}
                          </TableCell>
                          <TableCell>
                            <Button variant="contained"
                              style={{
                                backgroundColor: buttonBackgroundColor,
                                color: "white",
                                minWidth: "70px",
                              }} onClick={() => renderDoc(url)}>View</Button>
                          </TableCell>
                        </TableRow>
                      )
                  )}

                  {/* doubt */}
                  {/* {filteredMarkSheets.map(([level, url], index) => (
                    <TableRow key={level}>
                      <TableCell>{institutionDetails[index]?.certificate || 'Unknown Institution'}</TableCell>
                      <TableCell>
                        <Button onClick={() => window.open(url, '_blank')}>
                          View
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))} */}

                  {(!markSheets || filteredMarkSheets.length === 0) && (
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        style={{ textAlign: "center", height: "40px" }}
                      >
                        <i
                          className="fa fa-exclamation-circle"
                          style={{ marginLeft: "5px" }}
                        />{" "}
                        No marksheets available
                      </TableCell>
                    </TableRow>
                  )}
                  {filteredCertificate.map(
                    ([level, url], index) =>
                      url && ( // Only display the row if the url is present
                        <TableRow key={level}>
                          <TableCell>
                            Certificate for{" "}
                            {institutionDetails[index]?.institution ||
                              "Unknown Institution"}
                          </TableCell>
                          <TableCell>
                            <Button variant="contained"
                              style={{
                                backgroundColor: buttonBackgroundColor,
                                color: "white",
                                minWidth: "70px",
                              }} onClick={() => renderDoc(url)}>View</Button>
                          </TableCell>
                        </TableRow>
                      )
                  )}
                  {(!certificate || filteredCertificate.length === 0) && (
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        style={{ textAlign: "center", height: "40px" }}
                      >
                        <i
                          className="fa fa-exclamation-circle"
                          style={{ marginLeft: "5px" }}
                        />{" "}
                        No certificate available
                      </TableCell>
                    </TableRow>
                  )}

                  {studentDetails && studentDetails.profilePicture && (
                    <TableRow key="profilePicture">
                      <TableCell>Profile Picture</TableCell>
                      <TableCell>
                        <Button variant="contained"
                          style={{
                            backgroundColor: buttonBackgroundColor,
                            color: "white",
                            minWidth: "70px",
                          }}
                          onClick={() =>
                            renderDoc(studentDetails.profilePicture)
                          }
                        >
                          View
                        </Button>
                      </TableCell>
                      {/* <TableCell>
                          <Button onClick={() => handleVerifyFile('profilePicture')}>Verify</Button>
                        </TableCell> */}
                    </TableRow>
                  )}
                </TableBody>
              </Table>

              <Dialog open={open} onClose={handleCloseModal}>
                <DialogTitle>{`Verify ${documentType}`}</DialogTitle>
                <DialogContent>
                  {/* Add verification content here */}
                  Are you sure you want to verify the {documentType}?
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseModal} variant="contained"
                    style={{
                      backgroundColor: buttonBackgroundColor,
                      color: "white",
                    }}>
                    Close
                  </Button>
                  <Button
                    onClick={() => handleVerifyFile(documentType)}
                    color="primary"
                    autoFocus
                  >
                    Verify
                  </Button>
                </DialogActions>
              </Dialog>

              <ToastContainer />
            </>
          </Grid>
          <br />
          <Grid item xs={6}>
            <Paper elevation={3} style={{ padding: "24px", height: "100%" }}>
              <Typography
                variant="h6"
                gutterBottom
                style={{ fontWeight: "bolder" }}
              >
                Institution Details
              </Typography>
              {studentDetails?.institutionDetails &&
                studentDetails?.institutionDetails.length > 0 ? (
                <TableContainer>
                  <Table
                    style={{
                      borderCollapse: "collapse",
                      border: "1px solid #ccc",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontWeight: "bold" }}>
                          Institution
                        </TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>
                          Year
                        </TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>
                          Full Time/Part Time
                        </TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>
                          Qualifications Achieved
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {studentDetails.institutionDetails.map(
                        (detail, index) => (
                          <TableRow key={index}>
                            <TableCell>{detail.institution}</TableCell>
                            <TableCell>{detail.year}</TableCell>
                            <TableCell>{detail.fullTimeOrPartTime}</TableCell>
                            <TableCell>
                              {detail.qualificationsAchieved}
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography>No institution details available</Typography>
              )}
            </Paper>
          </Grid>
          <br />
          <Grid item xs={12} md={6}>
            <Paper elevation={3} style={{ padding: "24px", height: "100%" }}>
              <Typography
                variant="h6"
                gutterBottom
                style={{ fontWeight: "bolder" }}
              >
                Course Schedule
              </Typography>
              <TableContainer>
                <Table
                  style={{
                    borderCollapse: "collapse",
                    border: "1px solid #ccc",
                  }}
                >
                  <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                    <TableRow>
                      <TableCell
                        style={{
                          fontWeight: "bold",
                          borderBottom: "2px solid #ccc",
                        }}
                      >
                        Start Module
                      </TableCell>
                      <TableCell
                        style={{
                          fontWeight: "bold",
                          borderBottom: "2px solid #ccc",
                        }}
                      >
                        Start Date
                      </TableCell>
                      <TableCell
                        style={{
                          fontWeight: "bold",
                          borderBottom: "2px solid #ccc",
                        }}
                      >
                        End Date
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {scheduleData.map((schedule, index) => (
                      <TableRow
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                        }}
                      >
                        <TableCell
                          style={{
                            borderBottom: "1px solid #ccc",
                            padding: "8px",
                          }}
                        >
                          {schedule.moduleDetail}
                        </TableCell>
                        <TableCell
                          style={{
                            borderBottom: "1px solid #ccc",
                            padding: "8px",
                          }}
                        >
                          {formatDateEnd(schedule.startDate)}
                        </TableCell>
                        <TableCell
                          style={{
                            borderBottom: "1px solid #ccc",
                            padding: "8px",
                          }}
                        >
                          {formatDateEnd(schedule.endDate)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
          <br />
          {/* </Grid> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseViewDialog} variant="secondary"
            style={{
              backgroundColor: buttonBackgroundColor,
              color: "white",
            }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>



      <Dialog open={openDeleteDialog} onClose={handleCancelDelete}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure to rejected{" "}
          <strong>{selectedStudent ? selectedStudent.name : ""}</strong>?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            No
          </Button>
          <Button onClick={handleDelete} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openApproveDialog} onClose={handleCancelApprove}>
        <DialogTitle>Confirm Approval</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to approve{" "}
            <strong>{selectedStudent ? selectedStudent.name : ""}</strong> ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancelApprove}
            variant="contained"
            style={{
              backgroundColor: buttonBackgroundColor,
              color: "white",
            }}
            disabled={isApproving}
          >
            Close
          </Button>
          <Box position="relative" display="inline-flex">
            <Button
              onClick={handleApprove}
              variant="contained"
              style={{
                backgroundColor: buttonBackgroundColor,
                color: "white",
              }}
              disabled={isApproving}
            >
              {isApproving ? "Approving..." : "Approve"}
            </Button>
            {isApproving && (
              <CircularProgress
                size={24}
                style={{



                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: -12,
                  marginLeft: -12,
                }}
              />
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    backgroundColor: "#f5f6f7",
  },
  drawer: {
    width: 260,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaper: {
    width: 260,
    backgroundColor: "#1E2A38",
    color: "#fff",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: "#F4F7FA",
    minHeight: "100vh",
  },
  header: {
    padding: "20px",
    backgroundColor: "#2186C8",
    color: "#fff",
    borderRadius: "8px",
    marginBottom: "30px",
    fontSize: "26px",
    fontWeight: "bold",
    textAlign: "center", // Align text to the right
    width: "100%", // Full width
    maxWidth: "1200px", // Increased maximum width
  },
  card: {
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 6px 15px rgba(0, 0, 0, 0.1)",
    marginBottom: "30px",
  },
  tableHead: {
    backgroundColor: "#2186C8",
    "& th": {
      color: "#fff",
      fontSize: "16px",
      fontWeight: "600",
    },
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f9f9f9",
    },
    "&:hover": {
      backgroundColor: "#e0f7ff",
      cursor: "pointer",
    },
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(3),
  },
  pagination: {
    display: "flex",
    listStyleType: "none",
    padding: 0,
    "& li": {
      margin: "0 5px",
    },
    "& a": {
      padding: "8px 12px",
      borderRadius: "4px",
      border: "1px solid #ddd",
      textDecoration: "none",
      color: "#555",
      fontSize: "14px",
      "&:hover": {
        backgroundColor: "#2186C8",
        color: "#fff",
      },
    },
    "& .active a": {
      backgroundColor: "#2186C8",
      color: "#fff",
    },
  },
  sidebarIcon: {
    color: "#fff",
  },
  listItem: {
    "&:hover": {
      backgroundColor: "#2D3E50",
    },
  },
  listItemText: {
    fontSize: "16px",
    fontWeight: "bold",
  },
}));

const App = () => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState("tab1");
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const [tabData, setTabData] = useState([
    {
      id: "tab1",
      title: "Students",
      icon: faTasks,
      tableHeaders: ["S.NO", "Name", "Image", "Email", "Phone", "Gender"],
      data: [],
    },
    {
      id: "tab2",
      title: "Diploma",
      icon: faProjectDiagram,
      tableHeaders: ["S.NO", "Name", "Image", "Email", "Phone", "Gender"],
      data: [],
    },
    {
      id: "tab3",
      title: "Advance Diploma",
      icon: faBell,
      tableHeaders: ["S.NO", "Name", "Image", "Email", "Phone", "Gender"],
      data: [],
    },
    // {
    //   id: 'tab4',
    //   title: 'WSQ',
    //   icon: faGraduationCap,
    //   tableHeaders: ['ID', 'Name', 'Image', 'Email', 'Phone', 'Gender'],
    //   data: [
    //     { id: 1, name: 'William Wilson', image: 'img7.jpg', email: 'william@example.com', phone: '111-222-3333', gender: 'Male' },
    //     { id: 2, name: 'Sophia Anderson', image: 'img8.jpg', email: 'sophia@example.com', phone: '444-555-6666', gender: 'Female' },
    //     { id: 3, name: 'Alexander Martinez', image: 'img9.jpg', email: 'alexander@example.com', phone: '777-888-9999', gender: 'Male' },
    //   ]
    // },
    {
      id: "tab5",
      title: "Staff Details",
      icon: faChalkboardUser,
      tableHeaders: ["S.NO", "Name", "Image", "Email", "Phone", "Gender"],
      data: [],
    },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [studentsResponse, staffResponse] = await Promise.all([
          axios.get("students"), // Replace with your actual API URL for students
          axios.get("facilitators"), // Replace with your actual API URL for staff
        ]);

        const studentsData = studentsResponse.data
          .filter((item) => item.status === "active") // Filter by active students
          .map((item) => ({
            id: item.id,
            name: item.name,
            image: item.profileUrl ? item.profileUrl : "default.jpg", // Assuming a default image if profileUrl is null
            email: item.email,
            phone: item.phone,
            gender: item.gender,
            type: item.type,
            status: item.status,
          }));

        const staffData = staffResponse.data.map((item) => ({
          id: item.id,
          name: item.name,
          image: "default.jpg", // Assuming no image provided for staff
          email: item.email,
          phone: item.phone,
          gender: item.gender,
        }));

        const diplomaData = studentsData.filter(
          (item) => item.type === "diploma"
        );
        const advanceDiplomaData = studentsData.filter(
          (item) => item.type === "advance_diploma"
        );

        setTabData((prevTabData) =>
          prevTabData.map((tab) => {
            if (tab.id === "tab1") {
              return { ...tab, data: studentsData }; // Assuming tab1 should have all students data
            }
            if (tab.id === "tab2") {
              return { ...tab, data: diplomaData };
            }
            if (tab.id === "tab3") {
              return { ...tab, data: advanceDiplomaData };
            }
            if (tab.id === "tab5") {
              return { ...tab, data: staffData };
            }
            return tab;
          })
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const toggleTab = (tabId) => {
    setActiveTab(tabId);
  };

  const activeTabData = tabData.find((tab) => tab.id === activeTab);
  const pageCount = Math.ceil(activeTabData.data.length / itemsPerPage);
  const offset = currentPage * itemsPerPage;
  const currentPageData = activeTabData.data.slice(
    offset,
    offset + itemsPerPage
  );

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <Paper
      sx={{
        maxWidth: "1300px",
        margin: "auto",
        padding: "20px",
        borderRadius: "15px",
        boxShadow: 3,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
      }}
    >
      {/* <h1 
      </h1> */}
      <Tabs
        value={activeTab}
        onChange={(e, tabId) => toggleTab(tabId)}
        indicatorColor="primary"
      >
        {tabData.map((tab) => (
          <Tab
            key={tab.id}
            value={tab.id}
            label={
              <div className={classes.customNavLink}>
                <FontAwesomeIcon icon={tab.icon} className="me-2" /> {tab.title}
              </div>
            }
          />
        ))}
      </Tabs>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {activeTabData.tableHeaders.map((header) => (
                <TableCell key={header}>{header}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {currentPageData.map((item, index) => (
              <TableRow key={item.id}>
                <TableCell>{offset + index + 1}</TableCell>
                {activeTabData.tableHeaders.slice(1).map((header) => (
                  <TableCell key={header}>
                    {header.toLowerCase() === "image" ? (
                      <img
                        src={item.image}
                        alt={item.name}
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "20%",
                        }}
                      />
                    ) : (
                      item[header.toLowerCase()]
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div
        sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
      >
        <ReactPaginate
          previousLabel={"Previous"}
          nextLabel={"Next"}
          pageCount={pageCount}
          onPageChange={handlePageChange}
          containerClassName={"pagination"}
          activeClassName={"active"}
          previousClassName={"page-item"}
          nextClassName={"page-item"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousLinkClassName={"page-link"}
          nextLinkClassName={"page-link"}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
        />
      </div>
    </Paper>
  );
};

const Adhome = () => {
  return (
    <div style={{
      position: 'relative',
      minHeight: '110vh',
      // Prevents content overflow
    }}>
      {/* Full-screen background */}
      <div style={{
        backgroundColor: '#285588', // Consistent color
        width: '100%',  // Stretches to full width
        height: '100%', // Stretches to full height
        position: 'fixed', // Ensures it stays in place across views
        top: 0,
        left: 0,
        zIndex: -1, // Ensures it is below all content
      }} />

      {/* Content */}
      <div style={{
        position: 'relative', // Ensures content stays above the background
        zIndex: 1,
      }}>

        <Header />
        <br />
        <div style={{ flexDirection: "column", alignItems: "center" }}>
          <Ap />
          <br />
          <Dashboard />
          <br />
          <WelcomeBoxes />
          <br />
          {/* <App /> */}
        </div>
        <br />
        {/* <div
          style={{
            maxWidth: '1300px',
            margin: '0 auto',
            position: 'relative', // Position for absolute positioning of common name
            backgroundColor: 'rgba(255, 255, 255, 0.3)', // White with 50% opacity
            borderRadius: '10px',
            boxShadow: '0 8px 15px rgba(0, 0, 0, 0.2)', // Shadow effect
            padding: '10px', // Optional: for spacing
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Optional: shadow effect
          }}
       
        >
          <div
            style={{
              position: 'absolute',
              color: 'white',
              top: '16px',
              left: '16px',
              fontWeight: 'bold',
              fontSize: '1.6em', // Adjust the size as needed
              zIndex: 1, // Ensure it is above other content
            }}
          >
            Course Catergories
          </div>
       
          <CategoryStudentWise />
        </div> */}
      </div>
    </div>
  );
};

export default Adhome;
